class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      quickproductrow();
      bindQuickViewButtons();      
      $th_refreshWishlistItems();       
      // updateFLCprice();   
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector('body').classList.add('search-type')
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('body').classList.remove('search-type')
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
// if(document.querySelectorAll('.variant-grid')){
//   function quickAddButton(){
//     document.querySelectorAll('.variant-grid').forEach(function(sizeList){
//       sizeList.addEventListener('click',function(e){
//         e.preventDefault();
//         let variant_id = sizeList.dataset.id;
//         let error_grid_outer = sizeList.closest('.snippet-product-grid');
//         let error_grid = error_grid_outer.querySelector('.grid-error');
//         let formData = {
//           'items': [{
//             'id': variant_id,
//             'quantity': 1
//           }]
//         };
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(formData),
//         })
//         .then((response) => response.json())
//         .then((data) => {
//           if(data.status == 422)
//           {
//             error_grid.innerHTML = data.description;
//             setTimeout(function(e){
//               error_grid.innerHTML = '';
//             },2000);
//           }else{          
//             if(document.location.href.indexOf('/cart') > -1) {
//               window.location.href = "/cart";
//             }else{
//               if(typeof load_cart == 'function'){
//                 load_cart();
//                 setTimeout(function(e){
//                   document.querySelector('body').classList.add('open-drawer');
//                 },500);
//               }else{
//                 window.location.href = "/cart";
//               }          
//             }
//             const url = '/cart.js';
//             fetch(url)
//             .then((resp) => resp.json())
//             .then(function(data) {
//               var cart_count = data.item_count;
//               if(cart_count>0){
//                 document.querySelector('.cart-count').innerHTML = cart_count;
//               }else{
//                 document.querySelector('.cart-count').innerHTML = '';
//               }
//             })
//             .catch(function(error) {
//               console.log(error);
//             })
//           }
//         })
//         .catch((error) => {
//           console.error(error);
//         });
//       });
//     });    
//   }
//   quickAddButton();
// }


if (document.querySelectorAll('.variant-grid')) {
  function quickAddButton() {
    document.querySelectorAll('.variant-grid').forEach(function(sizeList) {
      // Prevent multiple event bindings
      if (!sizeList.classList.contains('quick-add-bound')) {
        sizeList.classList.add('quick-add-bound');

        sizeList.addEventListener('click', function(e) {
          // e.preventDefault();
          let variant_id = sizeList.dataset.id;
          let error_grid_outer = sizeList.closest('.snippet-product-grid');
          let error_grid = error_grid_outer.querySelector('.grid-error');
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(() => { error_grid.innerHTML = ''; }, 2000);
            } else {
              let isAppleDevice = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
              let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

              if (isAppleDevice && isSafari) {
                // ✅ On iOS Safari — redirect to checkout
                window.location.href = '/checkout';
              }else{
                // 🔹 Keep scroll position — don't reload page
                if (document.location.href.indexOf('/cart') > -1) {
                  window.location.href = '/cart';
                }else if(typeof load_cart === 'function') {
                  load_cart();
                  setTimeout(() => {
                    document.body.classList.add('open-drawer');
                    document.querySelector('.grid-variant-outer.active-grid-size').classList.remove('active-grid-size');
                  }, 500);
                } else {
                  // fallback: show success message instead of reloading
                  console.log('Item added to cart!');
                }

                // update cart count
                fetch('/cart.js')
                  .then((resp) => resp.json())
                  .then(function(data) {
                    var cart_count = data.item_count;
                    document.querySelector('.cart-count').innerHTML = cart_count > 0 ? cart_count : '';
                  })
                  .catch(console.log);
              }
            }
          })
          .catch(console.error);
        });
      }
    });
  }

  quickAddButton();
}



if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};


function productrow() { 
  var productslider = [];

  document.querySelectorAll('.product-images').forEach(function(Element){
    if (!(Element instanceof HTMLElement)) return;

    let productid = Element.dataset.id;

    let parentHasSwiper = false;
    let parent = Element.parentElement;
    while (parent) {
      if (parent.classList.contains('swiper') || parent.classList.contains('swiper-container')) {
        parentHasSwiper = true;
        break;
      }
      parent = parent.parentElement;
    }

    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerView: "auto",
      breakpoints: {
        0: {
          enabled: false
        },
        991: {
          enabled: true
        }
      }
    };
    
    if (parentHasSwiper) {
      swiperObject.a11y = false;
      swiperObject.nested = true;
      swiperObject.touchStartPreventDefault = false;
    }

    productslider[productid] = new Swiper(Element, swiperObject);
  });
}

// productrow();

document.querySelectorAll('.grid-apple-checkout').forEach((grid_apple) => {
  grid_apple.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if(screen.width > 991){
      grid_apple.closest('.snippet-product-grid').querySelector('.quick_add').click();
    }else{
      grid_apple.closest('.snippet-product-grid').querySelector('.quick_view_button').click();
    }

      function isIOS() {
          return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        }
        if (isIOS()) {
          document.querySelectorAll('.snippet-quick-buy-popup').forEach(el => {
            el.classList.add('ios-click');
          });
        }

  });

});

function quickproductrow() {
if(document.querySelectorAll('.quick_add')) document.querySelectorAll('.quick_add').forEach((quick_add) => {
  quick_add.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelectorAll('.grid-variant-outer').forEach((el) => {
      el.classList.remove('active-grid-size');
    });
    const targetGrid = quick_add.closest('.snippet-product-grid')?.querySelector('.grid-variant-outer');
    if (targetGrid) targetGrid.classList.add('active-grid-size');
  });
});
document.addEventListener('click', function(e){
  if (!e.target.closest('.grid-variant-outer') && !e.target.closest('.quick_add')) {
    document.querySelectorAll('.grid-variant-outer').forEach((el) => {
      el.classList.remove('active-grid-size');
    });
  }
});
}
quickproductrow();



function bindQuickViewButtons() {
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html');
          const source = html.getElementById('section-quick-buy');

          document.body.classList.add('open-quick-buy');
          document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML =
            source.innerHTML;

          addToCart();
          setTimeout(() => quickviewslider(), 100);
        })
        .catch((e) => console.error(e));
    });
  });
}

// function updateFLCprice() {
//   document.querySelectorAll('.snippet-product-grid').forEach(grid => {
//     const meta = grid.querySelector('.grid-meta-btm');
//     const priceAttr = meta?.getAttribute('data-price');
//     if (!priceAttr) return;
//     const price = parseFloat(priceAttr) * 10;
//     const roundedPrice = price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
//     const flcDiv = grid.querySelector('.flc-div');
//     if (flcDiv) {
//       let newPriceDiv = flcDiv.querySelector('.new-price');
//       if (!newPriceDiv) {
//         newPriceDiv = document.createElement('div');
//         newPriceDiv.className = 'new-price';
//         flcDiv.appendChild(newPriceDiv);
//       }
//       newPriceDiv.textContent = `${roundedPrice} FLC`;
//     }
//   });
// }

// updateFLCprice();

// let flcUpdated = false;
// function updateFLCprice() {
//   if (flcUpdated) return; 
//   flcUpdated = true;
//   document.querySelectorAll('.snippet-product-grid').forEach(grid => {
//     const meta = grid.querySelector('.grid-meta-btm');
//     const priceAttr = meta?.getAttribute('data-price');
//     if (!priceAttr) return;
//     const price = parseFloat(priceAttr) * 10;
//     const roundedPrice = price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
//     const flcDiv = grid.querySelector('.flc-div');
//     if (flcDiv) {
//       let newPriceDiv = flcDiv.querySelector('.new-price');
//       if (!newPriceDiv) {
//         newPriceDiv = document.createElement('div');
//         newPriceDiv.className = 'new-price';
//         flcDiv.appendChild(newPriceDiv);
//       }
//       newPriceDiv.textContent = `${roundedPrice} FLC`;
//     }
//   });
// }
// updateFLCprice();




if (document.querySelectorAll('.userlist .user-click').length > 0) {
  document.querySelectorAll('.userlist .user-click').forEach(function(element) {
    element.addEventListener('click', function(event) {
      event.preventDefault();
      document.body.classList.add('open-account-popup');
      document.body.classList.remove('open-search');
      document.body.classList.remove('open-menu');
      document.querySelector('#predictive-search').style.display = 'none';
    });
  });
}
if (document.querySelectorAll('.main-acc-popup .popuo-close .close').length > 0) {
  document.querySelectorAll('.main-acc-popup .popuo-close .close').forEach(function(element) {
    element.addEventListener('click', function(event) {
      document.body.classList.remove('open-account-popup');
    });
  });
}
if (document.querySelector('.inner-account-popup .creat-account-btn .button') != null) {
  var main = document.querySelector('.customer.login');
  var creat = document.querySelector('.customer.register');
  document.querySelector('.inner-account-popup .creat-account-btn .button').addEventListener('click', function (e) {
    e.preventDefault();
    main.classList.add('hide-form');
    creat.classList.remove('hide-form');
  });
}
if (document.querySelector('.have-acc.back') != null) {
  var main = document.querySelector('.customer.login');
  var creat = document.querySelector('.customer.register');
  document.querySelector('.have-acc.back').addEventListener('click', function (e) {
    e.preventDefault();
    main.classList.remove('hide-form');
    creat.classList.add('hide-form');
  });
}

// document.addEventListener('DOMContentLoaded', function() {
//   if((/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) &&
//   /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
//     window.ApplePaySession &&
//     ApplePaySession.canMakePayments()
//   ) {
//     document.querySelectorAll('.pdp-apple-btn, .grid-meta-top-rgt').forEach(function(el) {
//       el.style.display = 'flex';
//     });
//   }
// });
document.addEventListener('DOMContentLoaded', function() {
  if((/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
    document.querySelectorAll('.pdp-apple-btn, .grid-meta-top-rgt').forEach(function(el) {
      el.style.display = 'flex';
    });
  }
});



// document.addEventListener("DOMContentLoaded", function() {
//   const soldOutBtns = document.querySelectorAll(".grid-variant-outer .variant-unavailable a");
//   soldOutBtns.forEach(function(btn) {
//     btn.addEventListener("click", function() {
//       localStorage.setItem("KlaviyoOpen", "true");
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", function() {
//   if (localStorage.getItem("KlaviyoOpen") === "true") {
//     setTimeout(function() {
//       const soldOutBtn = document.querySelector(".snippet-addto-cart .sold-out-btn");
//       if (soldOutBtn) {
//         soldOutBtn.click();
//         localStorage.removeItem("KlaviyoOpen");
//       }
//     }, 1000);
//   }
// });

document.addEventListener("DOMContentLoaded", function() {
  const soldOutBtns = document.querySelectorAll(".grid-variant-outer .variant-unavailable a");
  soldOutBtns.forEach(function(btn) {
    btn.addEventListener("click", function() {
      document.querySelectorAll('.grid-error').forEach(el => {
        el.style.display = 'none';
      });
      localStorage.setItem("KlaviyoOpen", "true");
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  if (localStorage.getItem("KlaviyoOpen") === "true") {
    const checkInterval = setInterval(function() {
      const bisTriggers = document.querySelectorAll('.choose-cart .klaviyo-bis-trigger');
      if (bisTriggers.length > 0) {
        console.log(bisTriggers,'-----')
        bisTriggers.forEach(trigger => trigger.click());
        localStorage.removeItem("KlaviyoOpen");
        clearInterval(checkInterval);
      }
    }, 3000);
  }
});

// document.addEventListener("DOMContentLoaded", function() {
//   if (localStorage.getItem("KlaviyoOpen") === "true") {
//     const checkInterval = setInterval(function() {
//       const bisTrigger = document.querySelector('.klaviyo-bis-trigger');
//       if (bisTrigger) {
//         bisTrigger.click();
//         localStorage.removeItem("KlaviyoOpen");
//         clearInterval(checkInterval);
//       }
//     }, 1000);
//   }
// });



setTimeout(function() {
document.querySelectorAll('.menu-drawer-currency button').forEach(button => {
  button.addEventListener('click', () => {
      document.body.classList.remove('open-menu');
  });
});
}, 1000);


document.addEventListener("DOMContentLoaded", function() {
  if(localStorage.getItem('recentlyViewedProducts')){
    document.querySelectorAll('.recently-view-count').forEach(function(view_count) {
      if(JSON.parse(localStorage.getItem('recentlyViewedProducts')).length > 0){
        view_count.textContent = JSON.parse(localStorage.getItem('recentlyViewedProducts')).length;
      }else{
        view_count.textContent = '';
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const btns = document.querySelectorAll(".redirect-to-faq");
  if (!btns.length) return;

  btns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const targetPage = "/pages/loyalty";
      const targetSection = "section-faq";

      // Check if current page is already the loyalty page
      if (window.location.pathname.includes(targetPage)) {
        // Smooth scroll to section
        const section = document.querySelector(`.${targetSection}`);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Redirect with hash so it scrolls automatically after load
        window.location.href = `${targetPage}#${targetSection}`;
      }
    });
  });

  // If redirected with hash, scroll smoothly after load
  if (window.location.hash) {
    const hash = window.location.hash.replace("#", "");
    const section = document.querySelector(`.${hash}`);
    if (section) {
      // Small delay to ensure page fully loaded before scroll
      setTimeout(() => {
        section.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }
});


let currentlyActiveAccordionItem = null;
const accordionItemHeaders = document.querySelectorAll(".ftr-list li a.acc-click");

accordionItemHeaders.forEach(accordionItemHeader => {
  accordionItemHeader.addEventListener("click", event => {
    // Prevent default link behavior
    event.preventDefault();

    if (currentlyActiveAccordionItem && currentlyActiveAccordionItem !== accordionItemHeader) {
      currentlyActiveAccordionItem.classList.remove("active");
      const previouslyActiveAccordionItemBody = currentlyActiveAccordionItem.nextElementSibling;
      previouslyActiveAccordionItemBody.style.maxHeight = 0;
    }

    accordionItemHeader.classList.toggle("active");
    currentlyActiveAccordionItem = accordionItemHeader;

    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});

// Klaviyo Form Translation
document.addEventListener("DOMContentLoaded", function() {
  const klaviyoForm = document.querySelector('.klaviyo-form-WGMdPV');
  if (!klaviyoForm) return;

  const currentUrl = window.location.href;
  const isNL = currentUrl.includes('/nl');
  const isDe = currentUrl.includes('/de');

  if (!isNL && !isDe) return;

  const translations = {
    nl: {
      emailPlaceholder: 'E-mailadres',
      termsText: 'Door dit formulier te verzenden, ga je akkoord met de Algemene Voorwaarden',
      subscribeButton: 'Inschrijven',
      successMessage: '✓ Bedankt voor je inschrijving!'
    },
    de: {
      emailPlaceholder: 'E-Mail-Adresse',
      termsText: 'Mit dem Absenden dieses Formulars akzeptierst du die Allgemeinen Geschäftsbedingungen',
      subscribeButton: 'Anmelden',
      successMessage: '✓ Danke für deine Anmeldung!'
    }
  };

  const lang = isNL ? 'nl' : 'de';

  function translateForm() {
    const emailInput = klaviyoForm.querySelector('input#email_01KA17YCM6H2TSY7CKVYESB6NZ');
    if (emailInput) {
      emailInput.setAttribute('placeholder', translations[lang].emailPlaceholder);
    }

    const termsLabel = klaviyoForm.querySelector('label[for="Accepts%20Marketing__3__5"] div');
    if (termsLabel && termsLabel.textContent.includes('Terms')) {
      termsLabel.textContent = translations[lang].termsText;
    }

    const subscribeButton = klaviyoForm.querySelector('button.go2580892260');
    if (subscribeButton && subscribeButton.textContent.includes('Subscribe')) {
      subscribeButton.textContent = translations[lang].subscribeButton;
    }

    const successMessage = klaviyoForm.querySelector('.go3176171171 span');
    if (successMessage && successMessage.textContent.includes('Thanks')) {
      successMessage.textContent = translations[lang].successMessage;
    }
  }

  const observer = new MutationObserver(function(mutations, obs) {
    translateForm();
  });

  observer.observe(klaviyoForm, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    translateForm();
  }, 500);

  setTimeout(() => {
    translateForm();
  }, 1500);
});